<script lang="ts" setup>
import { Event } from '@/models/Event';
import { Location } from '@/models/Location';
import { formRules } from '@/helpers/tools';
import LocationSelectField from '@/components/location/SelectField.vue';

defineProps<{
    record: Event;
}>();

const emit = defineEmits(['input']);

function onEventLocationSelect(locRec: Location | null) {
    if (locRec) {
        emit('input', locRec.id);
    } else {
        emit('input', null);
    }
}
</script>
<template>
    <LabelField :label="$t('event_location')" :label-tip="$t('event_location_help')">
        <LocationSelectField
            :location-id="record.location_id"
            :organizer-id="record.organizer_id"
            :placeholder="String($t('placeholder_event_info_categories_location_id'))"
            :show-edit="false"
            :rules="record.event_class === 'permanent_exhibition' ? [formRules.required] : []"
            @selected="onEventLocationSelect($event)"
        ></LocationSelectField>
    </LabelField>
</template>
